import axios from "axios";

const host = "https://i.eyeled.de/eccpack/getDumps.php"

const userName =  'eyeupdate';
const password = 'tawzN6';


export default {

    sendErrorMessage(error){
        return axios.post(host,error,{
            params:{
                name : `web_${process.env.VUE_APP_PUSH_NAME}_${process.env.VUE_APP_VERSION}_`
            },
            auth: {
                username: userName,
                password: password
            }
        });
    },
    sendDebugErrorMessage(error){
        return axios.post(host,error,{
            params:{
                name : `web_${process.env.VUE_APP_PUSH_NAME}_${process.env.VUE_APP_VERSION}_debug_`
            },
            auth: {
                username: userName,
                password: password
            }
        });
    }

}
